import { FeatureExpansionRequestTypes } from '@webapp/core/services/Marketo'

export const AP_PO_EXPORT_PROMO_SURFACE = 'ap_po_complete_modal'
export const AP_PO_EXPORT_PROMO_EXPERIMENT = 'ap_po_complete_modal_v1'
export const AP_PO_EXPORT_PROMO_FEATURE = FeatureExpansionRequestTypes.AP
export const AP_PO_EXPORT_PROMO_MIN_RECORD_COUNT = 10
